import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  FaMobileAlt,
  FaGlobe,
  FaStore,
  FaShoppingCart,
  FaSyncAlt,
  FaTools,
  FaArrowRight,
  FaCheck,
} from 'react-icons/fa';
import './Services.css';

const services = [
  {
    icon: <FaMobileAlt />,
    title: 'Application Mobile',
    subtitle: 'Android & iOS',
    desc: "Développement d'applications mobiles natives et hybrides. Interface intuitive, performances optimales et expérience utilisateur soignée pour toucher vos clients sur tous les appareils.",
    features: [
      'Applications Android & iOS',
      'Design UI/UX sur mesure',
      'Notifications push',
      'Mode hors ligne',
      'Publication sur les stores',
    ],
  },
  {
    icon: <FaGlobe />,
    title: 'Application Web',
    subtitle: 'Sur mesure',
    desc: "Conception d'applications web complètes et performantes. Tableaux de bord, outils métier, plateformes SaaS... Nous développons la solution adaptée à votre activité.",
    features: [
      'Applications métier',
      'Tableaux de bord',
      'API REST',
      'Base de données optimisée',
      'Hébergement sécurisé',
    ],
  },
  {
    icon: <FaStore />,
    title: 'Site Vitrine',
    subtitle: 'Votre image en ligne',
    desc: "Création de sites vitrines modernes, rapides et optimisés pour le référencement. Présentez votre activité, vos services et générez des contacts qualifiés.",
    features: [
      'Design responsive',
      'Optimisation SEO',
      'Formulaire de contact',
      'Intégration Google Maps',
      'Chargement ultra rapide',
    ],
  },
  {
    icon: <FaShoppingCart />,
    title: 'Site E-commerce',
    subtitle: 'Vendez en ligne',
    desc: "Boutique en ligne complète avec gestion des produits, paiement sécurisé et suivi des commandes. Vendez vos produits et services 24h/24.",
    features: [
      'Catalogue produits',
      'Paiement sécurisé',
      'Gestion des commandes',
      'Suivi livraison',
      'Tableau de bord vendeur',
    ],
  },
  {
    icon: <FaSyncAlt />,
    title: 'Refonte de Site',
    subtitle: 'Modernisation',
    desc: "Votre site est obsolète ou ne génère pas de résultats ? Nous le modernisons avec un design actuel, des performances améliorées et un SEO renforcé.",
    features: [
      'Audit complet',
      'Nouveau design',
      'Migration des données',
      'Optimisation performances',
      'Amélioration SEO',
    ],
  },
  {
    icon: <FaTools />,
    title: 'Maintenance & Évolution',
    subtitle: 'Accompagnement continu',
    desc: "Un site web a besoin d'évoluer. Nous assurons la maintenance technique, les mises à jour de sécurité et l'ajout de nouvelles fonctionnalités.",
    features: [
      'Mises à jour régulières',
      'Sauvegardes automatiques',
      'Support technique',
      'Évolutions fonctionnelles',
      'Monitoring 24/7',
    ],
  },
];

const Services = () => {
  return (
    <main className="page-services">
      <Helmet>
        <title>Services Création Site Web & Application Mobile | AGKG Créations - Béziers</title>
        <meta name="description" content="Découvrez nos services de création de sites internet, applications mobiles Android & iOS, sites e-commerce et applications web sur mesure. Développeur web à Béziers, Montpellier et toute la France." />
        <link rel="canonical" href="https://agkgcreations.fr/services" />
        <meta property="og:title" content="Services Création Site Web & Application Mobile | AGKG Créations" />
        <meta property="og:description" content="Création de sites vitrines, e-commerce, applications web et mobiles sur mesure. Développeur web Béziers, Montpellier, Hérault." />
        <meta property="og:url" content="https://agkgcreations.fr/services" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            Nos <span>services</span>
          </h1>
          <p className="section-subtitle">
            Des solutions digitales complètes pour répondre à tous vos besoins web et mobile
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <p className="services-intro">
            Que vous soyez une entreprise, un artisan, un commerçant ou une startup, AGKG Créations
            vous accompagne dans la création de votre site internet ou application mobile.
            Basés à Agde dans l'Hérault, nous intervenons à Béziers, Montpellier, Toulouse et
            dans toute la France pour concevoir des solutions digitales performantes et adaptées
            à votre activité.
          </p>
          <div className="services-list">
            {services.map((service, index) => (
              <div
                key={index}
                className={`service-detail ${index % 2 !== 0 ? 'reverse' : ''}`}
              >
                <div className="service-detail-content">
                  <div className="service-detail-icon">{service.icon}</div>
                  <div className="service-detail-subtitle">{service.subtitle}</div>
                  <h2>{service.title}</h2>
                  <p>{service.desc}</p>
                  <ul className="service-features">
                    {service.features.map((feat, i) => (
                      <li key={i}>
                        <FaCheck className="feature-check" /> {feat}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" className="btn btn-primary">
                    Demander un devis <FaArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="services-cross-links">
            <Link to="/tarifs" className="btn btn-secondary">
              Voir nos tarifs <FaArrowRight />
            </Link>
            <Link to="/projets" className="btn btn-secondary">
              Voir nos réalisations <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
